import {Box} from '@viptech/react-components'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import useEdgeServers from 'src/hooks/api/edge-servers/useEdgeServers'
import {useQueryParams} from 'src/hooks/useQuery'
import {useCompaniesSelector} from 'src/layouts/main-layout/companies-selector/companies-selector-context'
import {ContainerPaperContent} from 'src/layouts/main-layout/LayoutBase'
import ConfigurationEdgeServer from 'src/pages/edge-servers/components/modal/ConfigurationEdgeServer'
import Modal from '../../components/modal/ModalCustom'
import EdgeServersTable from './components/table/EdgeServersTable'
import {SearchTypeEdgeServers, TobBarHeader} from './components/top-bar/TobBarHeader'

function EdgeServers() {
  const [search, setSearch] = useState<SearchTypeEdgeServers>({})

  const {selectedCompanies} = useCompaniesSelector()

  const query = useQueryParams()
  const navigate = useNavigate()
  const {data, fetchNextPage, isFetchingNextPage, isLoading, hasNextPage, refetch, isRefetching} = useEdgeServers({
    filter: {companyIds: selectedCompanies.map((it) => it.id)},
    search,
  })

  return (
    <ContainerPaperContent>
      <TobBarHeader search={search} setSearch={setSearch} refetch={refetch} loading={isLoading || isRefetching} />

      <Box style={{height: '80vh'}}>
        <EdgeServersTable
          servers={data?.pages.flatMap((it) => it.entities) ?? []}
          isLoadingAlarms={isLoading}
          fetchNextPage={fetchNextPage}
          isFetchingNextPage={isFetchingNextPage}
          hasNextPage={hasNextPage}
        />
      </Box>

      <Modal isOpen={!!query.get('id')} closeModal={() => navigate('/registers/edge-servers')} backgroundColor='white' width='40%' minHeight='600px'>
        <ConfigurationEdgeServer id={Number(query.get('id') ?? 0)} closeModal={() => navigate('/registers/edge-servers')} />
      </Modal>
    </ContainerPaperContent>
  )
}

export default EdgeServers
